import { useNavigate } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { createClaspType } from "../../helpers/http_clasp_types_requests";

export default function ClaspTypeNew() {

    const navigate = useNavigate();

    const formFieldList = [
        {
            title: "Detaçhes de Fecho",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        createClaspType(data, () => navigate('/fechos'))
    };

    return <DynamicFormPage title={"Fecho - Cadastro"} onSubmit={handleSubmit} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;

};
